import { prepareMarket, prepareEmptyMarket } from "../../helpers";
export const getMarketsRegular = (marketsInConfig, markets, event) => {
    return [
        prepareMarket(markets, marketsInConfig, event.isLive)
            || prepareEmptyMarket(event.id, marketsInConfig[0].template, 0)
    ];
};
//# sourceMappingURL=getMarketsRegular.js.map